export default "assets/images/404-3a7a222d.png";